import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactSortable } from 'react-sortablejs';

import { Button } from '../../../components/material-ui/Button';
import { sidebarButton } from '../../../components/Sidebar/constants';
import { PartitionSettingRow } from './PartitionSettingRow';
import { useStyles } from './useStyles';

export const PartitionSetting = memo(({ partitions, setPartitions, onResetClick, onCheckItem }) => {
    const { t: translate } = useTranslation();
    const classes = useStyles();

    return (
        <>
            <Button variant="contained" color="primary" className={classes.resetButton} onClick={onResetClick}>
                {translate('reset')}
            </Button>
            <ReactSortable list={partitions} setList={setPartitions} chosenClass={classes.grab} className={classes.list} delay="200">
                {Object.entries(partitions).map(
                    ([key, { id, visible }]) =>
                        sidebarButton[id] && (
                            <PartitionSettingRow key={key} index={key} item={sidebarButton[id]} visible={visible} onCheck={onCheckItem} />
                        )
                )}
            </ReactSortable>
        </>
    );
});

PartitionSetting.displayName = 'PartitionSetting';
